/* eslint-disable import/no-cycle */
import { APIService } from './ApiService';

export const getAllRatings = (page, limit, search, isWithComment, selectRating, courseId, sortingType) =>
  APIService.get(
    `ratings/lectures?page=${page}&limit=${limit}&search=${search}&isWithComment=${isWithComment}&selectRating=${selectRating}${
      courseId ? `&courseId=${courseId}` : ''
    }${sortingType ? `&sortingType=${sortingType}` : ''}`,
  );

export const getModulesStats = ({ courseId, fromDate, toDate }) => {
  return APIService.get(
    `ratings/lectures/modules-stats?${courseId ? `courseId=${courseId}&` : ''}${
      fromDate ? `fromDate=${fromDate}&` : ''
    }${toDate ? `toDate=${toDate}` : ''}`,
  );
};

export const getTeacherCommentsModulesStats = ({ courseId, fromDate, toDate, teacherId }) => {
  return APIService.get(
    `ratings/teacher-comments/modules-stats?${courseId ? `courseId=${courseId}&` : ''}${
      fromDate ? `fromDate=${fromDate}&` : ''
    }${toDate ? `toDate=${toDate}` : ''}${teacherId ? `&teacherId=${teacherId}` : ''}`,
  );
};

export const getExercisesModulesStats = ({ courseId, fromDate, toDate }) => {
  return APIService.get(
    `ratings/exercises/modules-stats?${courseId ? `courseId=${courseId}&` : ''}${
      fromDate ? `fromDate=${fromDate}&` : ''
    }${toDate ? `toDate=${toDate}` : ''}`,
  );
};

export const getAllSectionsStats = ({ courseId, fromDate, toDate }) => {
  return APIService.get(
    `ratings/lectures/all-sections-stats?${courseId ? `courseId=${courseId}&` : ''}${
      fromDate ? `fromDate=${fromDate}&` : ''
    }${toDate ? `toDate=${toDate}` : ''}`,
  );
};

export const getAllSectionsTeacherCommentsStats = ({ courseId, fromDate, toDate, teacherId }) => {
  return APIService.get(
    `ratings/teacher-comments/all-sections-stats?${courseId ? `courseId=${courseId}&` : ''}${
      fromDate ? `fromDate=${fromDate}&` : ''
    }${toDate ? `toDate=${toDate}` : ''}${teacherId ? `&teacherId=${teacherId}` : ''}`,
  );
};

export const getAllSectionsExercisesStats = ({ courseId, fromDate, toDate }) => {
  return APIService.get(
    `ratings/exercises/all-sections-stats?${courseId ? `courseId=${courseId}&` : ''}${
      fromDate ? `fromDate=${fromDate}&` : ''
    }${toDate ? `toDate=${toDate}` : ''}`,
  );
};

export const getAllLecturesStats = ({ fromDate, toDate, courseId }) => {
  return APIService.get(
    `ratings/lectures/all-lectures-stats?${fromDate ? `fromDate=${fromDate}&` : ''}${toDate ? `toDate=${toDate}` : ''}${
      courseId ? `&courseId=${courseId}` : ''
    }`,
  );
};

export const getAllExercisesStats = ({ fromDate, toDate, courseId }) => {
  return APIService.get(
    `ratings/exercises/all-exercises-stats?${fromDate ? `fromDate=${fromDate}&` : ''}${
      toDate ? `toDate=${toDate}` : ''
    }${courseId ? `&courseId=${courseId}` : ''}`,
  );
};

export const getAllTeacherCommentsRatings = params => {
  const queryParams = new URLSearchParams();

  if (params.page) queryParams.append('page', params.page);
  if (params.limit) queryParams.append('limit', params.limit);
  if (params.courseId) queryParams.append('courseId', params.courseId);
  if (params.teacherId) queryParams.append('teacherId', params.teacherId);
  if (params.fromDate) queryParams.append('fromDate', params.fromDate);
  if (params.toDate) queryParams.append('toDate', params.toDate);
  if (params.search) queryParams.append('search', params.search);
  if (params.sortingType) queryParams.append('sortingType', params.sortingType);

  return APIService.get(`ratings/teacher-comments/all-ratings?${queryParams.toString()}`);
};

export const getAllExerciseVerificationRatings = params => {
  const queryParams = new URLSearchParams();
  if (params.page) queryParams.append('page', params.page);
  if (params.limit) queryParams.append('limit', params.limit);
  if (params.courseId) queryParams.append('courseId', params.courseId);
  if (params.teacherId) queryParams.append('teacherId', params.teacherId);
  if (params.fromDate) queryParams.append('fromDate', params.fromDate);
  if (params.toDate) queryParams.append('toDate', params.toDate);
  if (params.search) queryParams.append('search', params.search);
  if (params.sortingType) queryParams.append('sortingType', params.sortingType);
  if (params.statusType) queryParams.append('statusType', params.statusType);

  return APIService.get(`ratings/exercises-verification/all-ratings?${queryParams.toString()}`);
};

export const getExerciseVerificationRatingsCounts = params => {
  const queryParams = new URLSearchParams();
  if (params.courseId) queryParams.append('courseId', params.courseId);
  if (params.teacherId) queryParams.append('teacherId', params.teacherId);
  if (params.fromDate) queryParams.append('fromDate', params.fromDate);
  if (params.toDate) queryParams.append('toDate', params.toDate);
  if (params.statusType) queryParams.append('statusType', params.statusType);

  return APIService.get(`ratings/exercises-verification/stats?${queryParams.toString()}`);
};

export const getTeacherCommentsPeriodicRatings = params => {
  const queryParams = new URLSearchParams();

  if (params.courseId) queryParams.append('courseId', params.courseId);
  if (params.teacherId) queryParams.append('teacherId', params.teacherId);
  if (params.periodType) queryParams.append('periodType', params.periodType);
  if (params.ratingType) queryParams.append('ratingType', params.ratingType);
  if (params.startDate) queryParams.append('startDate', params.startDate);
  if (params.endDate) queryParams.append('endDate', params.endDate);

  return APIService.get(`ratings/teacher-comments/periodic-ratings?${queryParams.toString()}`);
};

export const getAllTeacherCommentsExercisesStats = ({ fromDate, toDate, courseId, teacherId }) => {
  return APIService.get(
    `ratings/teacher-comments/all-exercises-stats?${fromDate ? `fromDate=${fromDate}&` : ''}${
      toDate ? `toDate=${toDate}` : ''
    }${courseId ? `&courseId=${courseId}` : ''}${teacherId ? `&teacherId=${teacherId}` : ''}`,
  );
};

export const getSectionsStats = ({ moduleId, fromDate, toDate }) => {
  return APIService.get(
    `ratings/lectures/sections-stats-by-module?${moduleId ? `moduleId=${moduleId}&` : ''}${
      fromDate ? `fromDate=${fromDate}&` : ''
    }${toDate ? `toDate=${toDate}` : ''}`,
  );
};

export const getTeacherCommentsSectionsStats = ({ moduleId, fromDate, toDate, teacherId }) => {
  return APIService.get(
    `ratings/teacher-comments/sections-stats-by-module?${moduleId ? `moduleId=${moduleId}&` : ''}${
      fromDate ? `fromDate=${fromDate}&` : ''
    }${toDate ? `toDate=${toDate}` : ''}${teacherId ? `&teacherId=${teacherId}` : ''}`,
  );
};

export const getExercisesSectionsStats = ({ moduleId, fromDate, toDate }) => {
  return APIService.get(
    `ratings/exercises/sections-stats-by-module?${moduleId ? `moduleId=${moduleId}&` : ''}${
      fromDate ? `fromDate=${fromDate}&` : ''
    }${toDate ? `toDate=${toDate}` : ''}`,
  );
};

export const getLecturesStats = ({ sectionId, fromDate, toDate }) => {
  return APIService.get(
    `ratings/lectures/lectures-stats-by-section?${sectionId ? `sectionId=${sectionId}&` : ''}${
      fromDate ? `fromDate=${fromDate}&` : ''
    }${toDate ? `toDate=${toDate}` : ''}`,
  );
};

export const getTeacherCommentsLecturesStats = ({ sectionId, fromDate, toDate, teacherId }) => {
  return APIService.get(
    `ratings/teacher-comments/lectures-stats-by-section?${sectionId ? `sectionId=${sectionId}&` : ''}${
      fromDate ? `fromDate=${fromDate}&` : ''
    }${toDate ? `toDate=${toDate}` : ''}${teacherId ? `&teacherId=${teacherId}` : ''}`,
  );
};

export const getExercisesLecturesStats = ({ sectionId, fromDate, toDate }) => {
  return APIService.get(
    `ratings/exercises/lectures-stats-by-section?${sectionId ? `sectionId=${sectionId}&` : ''}${
      fromDate ? `fromDate=${fromDate}&` : ''
    }${toDate ? `toDate=${toDate}` : ''}`,
  );
};

export const getSingleLectureStats = ({ subjectId, fromDate, toDate, contentVersion, isWithComments }) => {
  return APIService.get(
    `ratings/lectures/single-lecture-stats?${subjectId ? `sectionId=${subjectId}&` : ''}${
      fromDate ? `fromDate=${fromDate}&` : ''
    }${toDate ? `toDate=${toDate}` : ''}${contentVersion ? `&contentVersion=${contentVersion}` : ''}${
      isWithComments ? `&isWithComments=${isWithComments}` : ''
    }`,
  );
};
export const getSingleLectureTeacherCommentStats = ({ subjectId, fromDate, toDate, contentVersion, teacherId }) => {
  return APIService.get(
    `ratings/teacher-comments/single-lecture-stats?${subjectId ? `sectionId=${subjectId}&` : ''}${
      fromDate ? `fromDate=${fromDate}&` : ''
    }${toDate ? `toDate=${toDate}` : ''}${contentVersion ? `&contentVersion=${contentVersion}` : ''}${
      teacherId ? `&teacherId=${teacherId}` : ''
    }`,
  );
};

export const getSingleLectureExercisesStats = ({ subjectId, fromDate, toDate, contentVersion }) => {
  return APIService.get(
    `ratings/exercises/single-lecture-stats?${subjectId ? `sectionId=${subjectId}&` : ''}${
      fromDate ? `fromDate=${fromDate}&` : ''
    }${toDate ? `toDate=${toDate}` : ''}${contentVersion ? `&contentVersion=${contentVersion}` : ''}`,
  );
};

export const getSubjectContentVersions = subjectId =>
  APIService.get(`ratings/lectures/content-versions?subjectId=${subjectId}`);

export const postLectureRate = payload => APIService.post(`ratings/lectures`, { ...payload });

export const postTeacherCommentRate = payload => APIService.post(`ratings/teachers`, { ...payload });

export const postExerciseRate = payload => APIService.post(`ratings/exercises`, { ...payload });

export const postExerciseVerificationRate = payload =>
  APIService.post(`ratings/exercises-verification`, { ...payload });

export const getExerciseVerificationInformations = subjectId =>
  APIService.get(`ratings/exercises-verification/${subjectId}`);

export const postTicketCommentRating = payload => APIService.post(`ratings/ticket-answers`, { ...payload });

export const getLectureInformations = subjectId => APIService.get(`ratings/lectures/${subjectId}`);

export const getExerciseInformations = subjectId => APIService.get(`ratings/exercises/${subjectId}`);

export const getSubjectRatings = ({
  from,
  to,
  sortingType,
  page,
  limit,
  contentVersion,
  subjectId,
  isWithComments,
}) => {
  return APIService.get(
    `ratings/lectures/subject-ratings?${from ? `fromDate=${from}&` : ''}${to ? `toDate=${to}&` : ''}${
      sortingType ? `sortingType=${sortingType}&` : ''
    }${page ? `page=${page}&` : ''}${limit ? `limit=${limit}&` : ''}${
      contentVersion ? `contentVersion=${contentVersion}&` : ''
    }${subjectId ? `subjectId=${subjectId}` : ''}${isWithComments ? `&isWithComments=${isWithComments}` : ''}`,
  );
};

export const getTicketAnswersRatings = ({ from, to, sortingType, page, limit, courseId, teacherId }) => {
  return APIService.get(
    `ratings/ticket-answers/all-ratings?${from ? `fromDate=${from}&` : ''}${to ? `toDate=${to}&` : ''}${
      sortingType ? `sortingType=${sortingType}&` : ''
    }${page ? `page=${page}&` : ''}${limit ? `limit=${limit}&` : ''}${courseId ? `courseId=${courseId}&` : ''}${
      teacherId ? `teacherId=${teacherId}` : ''
    }`,
  );
};

export const getMonthlyTicketAnswerRatingStats = ({ year, courseId, teacherId }) => {
  return APIService.get(
    `ratings/ticket-answers/monthly-stats?${year ? `year=${year}&` : ''}${courseId ? `courseId=${courseId}&` : ''}${
      teacherId ? `teacherId=${teacherId}` : ''
    }`,
  );
};

export const getSubjectTeacherCommentsRatings = ({
  from,
  to,
  sortingType,
  page,
  limit,
  contentVersion,
  subjectId,
  teacherId,
}) => {
  return APIService.get(
    `ratings/teacher-comments/subject-ratings?${from ? `fromDate=${from}&` : ''}${to ? `toDate=${to}&` : ''}${
      sortingType ? `sortingType=${sortingType}&` : ''
    }${page ? `page=${page}&` : ''}${limit ? `limit=${limit}&` : ''}${
      contentVersion ? `contentVersion=${contentVersion}&` : ''
    }${subjectId ? `subjectId=${subjectId}` : ''}${teacherId ? `&teacherId=${teacherId}` : ''}`,
  );
};

export const getSubjectExercisesRatings = ({ from, to, sortingType, page, limit, contentVersion, subjectId }) => {
  return APIService.get(
    `ratings/exercises/subject-ratings?${from ? `fromDate=${from}&` : ''}${to ? `toDate=${to}&` : ''}${
      sortingType ? `sortingType=${sortingType}&` : ''
    }${page ? `page=${page}&` : ''}${limit ? `limit=${limit}&` : ''}${
      contentVersion ? `contentVersion=${contentVersion}&` : ''
    }${subjectId ? `subjectId=${subjectId}` : ''}`,
  );
};
